import React from 'react'
import {observer} from 'mobx-react-lite'
import {useBasketStore} from '../../store/hooks/useStore'
import {Box, Flex, Text} from '../../vanilla'
import {DeliveryMapWithPinIcon, LocationIcon} from '../icons'

interface DeliveryAddressProps {
  showMapIcon?: boolean
  isHomepage?: boolean
}

export const DeliveryAddressContainer = ({
  showMapIcon = false,
  isHomepage = false
}: DeliveryAddressProps) => {
  const {addressDisplay} = useBasketStore()

  if (isHomepage) {
    return (
      <Flex
        gap="2px"
        align="flex-start"
        data-test-selector="delivery-address-summary"
      >
        <LocationIcon
          width="16px"
          height="auto"
          color="accent1"
          flexShrink="0"
          marginTop="2px"
        />
        <Text
          variant="text3"
          color="accent1"
          textDecoration="underline"
          data-cs-mask=""
        >
          {addressDisplay}
        </Text>
      </Flex>
    )
  }

  return (
    <Flex
      gap="16px"
      paddingRight={['0px', '48px']}
      data-test-selector="delivery-address-summary"
      >
      {showMapIcon && (
        <Box>
          <DeliveryMapWithPinIcon color="accent0" boxSize="60px" />
        </Box>
      )}
      <Box>
        <Text color="accent0" variant="text4">
          We'll deliver to:
        </Text>
        <Text variant="text3"  data-cs-mask="">{addressDisplay}</Text>
      </Box>
    </Flex>
  )
}

export const DeliveryAddress = observer(DeliveryAddressContainer)
